import { render, staticRenderFns } from "./detilsHalls.vue?vue&type=template&id=707a3e54&"
import script from "./detilsHalls.vue?vue&type=script&lang=js&"
export * from "./detilsHalls.vue?vue&type=script&lang=js&"
import style0 from "./detilsHalls.vue?vue&type=style&index=0&id=707a3e54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports